import { DataGrid, DataGridRow } from "~/components/DataGrid";
import { ColumnMetadata, RowSizes } from "~/components/DataGrid/types";
import { PlatformTableDataColumns, PlatformTableData } from "../..";
import { QueryResponse, SortDirections } from "~/modules/filters/types";
import { useInMemoryPlatformSort } from "./useInMemoryPlatformSort";
import { paginateItems } from "~/utils/functions/paginateItems";

// // // //

export function PlatformTable(props: {
    listQueryResponse: QueryResponse<PlatformTableData>;
    columns: ColumnMetadata<PlatformTableData, PlatformTableDataColumns>[];
    defaultSortField?: PlatformTableDataColumns;
}) {
    const {
        listQueryResponse,
        columns,
        defaultSortField = PlatformTableDataColumns.distributedMarketCap,
    } = props;
    const rows = listQueryResponse.results;

    const { query, setQuery, sortedItems } = useInMemoryPlatformSort({
        rows,
        sort: {
            field: defaultSortField,
            direction: SortDirections.desc,
        },
        pagination: {
            page: 1,
            perPage: 20,
        },
    });

    // Assign correct rank to each row
    const rankedItems = sortedItems.map((item, index) => {
        return {
            ...item,
            rank: index + 1,
        };
    });

    // ENHANCEMENT - make this a react hook?
    const paginatedResponse = paginateItems({
        results: rankedItems,
        page: query.pagination.page,
        perPage: query.pagination.perPage,
    });

    return (
        <DataGrid
            query={query}
            loading={false}
            columns={columns}
            rows={paginatedResponse.results}
            rowKey="id"
            bordered
            fixedHeader
            size={RowSizes.small}
            paginationState={paginatedResponse.pagination}
            analyticsTableName="platforms"
            fixedHeaderClassName="top-26"
            onChangeQuery={setQuery}
        >
            {({ row, rowIndex, scrollLeft }) => (
                <DataGridRow
                    key={row.id}
                    row={row}
                    columns={columns}
                    size={RowSizes.small}
                    striped={rowIndex % 2 === 1}
                    scrollLeft={scrollLeft}
                    bordered
                />
            )}
        </DataGrid>
    );
}
